import { createContext, useContext } from "react";
import type { CartState } from "./CartContext";

/**
 * Contesto e hook del carrello, separati dal provider (CartContext.tsx): un
 * file che esporta componenti deve esportare solo componenti, altrimenti il
 * fast refresh di Vite non può sostituirlo a caldo.
 */
export const CartContext = createContext<CartState | null>(null);

export function useCart(): CartState {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be used within CartProvider");
  return ctx;
}
